module.exports = __webpack_public_path__ + "static/media/Network.0ade207c.webm";